import { getDNSMI } from './gtm';

export const isDntEnabled = (): boolean =>
  (typeof navigator !== 'undefined' && navigator.doNotTrack === '1') || !!getDNSMI();
